import styled from 'styled-components';

import MatchCell from './views/matchCell/MainMatchCell';
import WHMatchCell from './views/matchCell/WHMatchCell';
import SkewMatchCell from './views/matchCell/SkewMatchCell';
import MatchCellText from './views/matchCell/TextMatchCell';
import MatchCellTextCentered from './views/matchCell/TextMatchCellCentered';

import MainTT from './views/tables/MainTT';
import SimpleTT from './views/tables/SimpleTT';
import TournamentTableSkew from './views/tables/SkewTT';
import TournamentTableStyle1 from './views/tables/MainTTStyle1';

import IncidentWithPhotos from './views/IncidentWithPhotos';
import IncidentWithoutPhotos from './views/IncidentWithoutPhotos';
import IncidentStyle3 from './views/IncidentStyle3';
import IncidentStyle4 from './views/IncidentStyle4';
import WHTTRow from './views/tables/WHTT';
import TextTT from './views/tables/TextTT';

import PlayersListText from './views/lists/PlayersListText';
import PlayersListWithChart from './views/lists/PlayersListWithChart';
import PlayersListSimple from './views/lists/PlayersListSimple';
import PlayersListStyle1 from './views/lists/PlayersListStyle1';
import WHPlayersList from './views/lists/WHPlayersList';
import SkewPlayerList from './views/lists/SkewPlayerList';

import H2HTableSimple from './views/h2h/H2HTableSimple';
import H2HTableSkew from './views/h2h/H2HTableSkew';
import H2HTableStyle3 from './views/h2h/H2HTableStyle3';
import H2HStyle4 from './views/h2h/H2HStyle4';

import F1SkewRow from './views/f1/F1SkewRow';
import F1ListRow from './views/f1/F1ListRow';
import H2HRadarChart from './views/h2h/H2HRadarChart';
import NationalFlag from './views/NationalFlag';

import {
    PlayerLogo3DJerseyBack,
    PlayerLogo3DJerseyFront,
    PlayerLogoJersey,
    PlayerLogoPhoto,
    PlayerLogoSPDKFace,
    PlayerRoundedPhoto
} from './views/playerLogo/SMPlayerLogo';

import { TeamLogo, TeamLogoEmpty, TeamLogoBlank } from './views/SMTeamLogo';

import { Title, SkewTitle, LeftAlignedTitle } from './views/titles';

import _ from 'lodash';

export default {
    Box: styled.div``,
    H1: styled.h1`
        font-size: 38px;
        line-height: 41px;
        font-weight: 700;
        text-align: center;
        padding: 20px 0 30px;
        margin: 0;
    `,
    Logo: styled.span`
        display: inline-block;
        .wdp-sm-plr-logo_jersey {
            padding: 7px;
        }
    `
};

class StyledUIFactory {
    constructor() {
        this.getDisplayPropType = this.getDisplayPropType.bind(this);
    }
    tournamentTable
    displayMap = {
        title: {
            default: Title,
            'Left Aligned': LeftAlignedTitle,
            SkewTitle: SkewTitle
        },
        playersList: {
            default: PlayersListSimple, //default is used if no display type matched
            PlayersListSimple: PlayersListSimple,
            PlayersListStyle1: PlayersListStyle1,
            PlayersListText: PlayersListText,
            PlayersListWithChart: PlayersListWithChart,
            WHPlayersList: WHPlayersList,
            SkewPlayerList: SkewPlayerList
        },
        matchCell: {
            default: MatchCell,
            MatchCell: MatchCell,
            TextMatchCell: MatchCellText,
            TextMatchCellCentered: MatchCellTextCentered,
            WHMatchCell: WHMatchCell,
            SkewMatchCell: SkewMatchCell
        },
        tournamentTable: {
            default: SimpleTT,
            TournamentTableExtended: MainTT,

            Simple: SimpleTT,
            TournamentTableSkew: TournamentTableSkew,
            WHTTRow: WHTTRow,
            Textual: TextTT,
            TournamentTableStyle1: TournamentTableStyle1
        },
        incidentCard: {
            default: IncidentWithoutPhotos,
            IncidentWithoutPhotos: IncidentWithoutPhotos,
            IncidentWithPhotos: IncidentWithPhotos,
            IncidentStyle3: IncidentStyle3,
            IncidentStyle4: IncidentStyle4
        },
        playerLogo: {
            default: PlayerLogoJersey,
            PlayerLogo3DJerseyBack: PlayerLogo3DJerseyBack,
            PlayerLogo3DJerseyFront: PlayerLogo3DJerseyBack,
            PlayerLogoJersey: PlayerLogoJersey,
            PlayerLogoPhoto: PlayerLogoPhoto,
            PlayerLogoSPDKFace: PlayerLogoSPDKFace,
            PlayerRoundedPhoto: PlayerRoundedPhoto
        },
        teamLogo: {
            default: TeamLogo,
            TeamLogo: TeamLogo,
            TeamLogoBlank: TeamLogoBlank,
            TeamLogoEmpty: TeamLogoEmpty
        },
        h2hTable: {
            default: H2HTableSimple,
            H2HTableSimple: H2HTableSimple,
            H2HTableSkew: H2HTableSkew,
            H2HTableStyle3: H2HTableStyle3,
            H2HStyle4: H2HStyle4,
            H2HRadarChart: H2HRadarChart
        },
        f1Table: {
            default: F1SkewRow
        },
        f1List: {
            default: F1ListRow
        },
        flag: {
            default: NationalFlag,
            skew: NationalFlag,
            round: NationalFlag
        }
    };

    skins = [
        {
            id: 'default',
            name: 'Default',
            displayMap: {
                title: 'default',
                playersList: 'default',
                matchCell: 'default',
                tournamentTable: 'default',
                incidentCard: 'default',
                h2hTable: 'default'
            }
        },
        {
            id: 'wh',
            name: 'WH',
            displayMap: {
                title: 'Left Aligned',
                playersList: 'WHPlayersList',
                matchCell: 'WHMatchCell',
                tournamentTable: 'WHTTRow',
                incidentCard: 'IncidentWithPhotos',
                h2hTable: 'default'
            }
        },
        {
            id: 'sw',
            name: 'SW',
            displayMap: {
                tournamentTable: 'SWTTRow',
                h2hTable: 'default'
            }
        },
        {
            id: 'text',
            name: 'Textual Skin',
            displayMap: {
                title: 'default',
                playersList: 'PlayersListText',
                matchCell: 'TextMatchCell',
                tournamentTable: 'Textual',
                incidentCard: 'IncidentWithoutPhotos',
                h2hTable: 'default'
            }
        },
        {
            id: 'skew',
            name: 'Skew Skin',
            displayMap: {
                title: 'SkewTitle',
                tournamentTable: 'TournamentTableSkew',
                matchCell: 'SkewMatchCell',
                playersList: 'SkewPlayerList',
                incidentCard: 'default',
                h2hTable: 'H2HTableSkew'
            }
        }
    ];

    getCustomComponentFromTheme(theme, element, widgetProps) {
        if (Object.keys(this.displayMap).indexOf(element) === -1) {
            console.warn('Unknownw standard component: ' + element);
            return null;
        }
        //Get display option for element in theme
        let themeDisplay = _.get(theme, `display.${element}`);

        //Check if widget has custom display property for element
        let widgetDisplay = _.get(widgetProps, `${element}Display`);

        //Get all display options for component
        let elementDisplayOptions = _.get(this.displayMap, `${element}`);

        //Get component with display option from widget custom display or from theme
        let requestedDisplay = _.get(elementDisplayOptions, widgetDisplay || themeDisplay);

        //If no such display option found, return default display option
        if (!requestedDisplay) requestedDisplay = _.get(elementDisplayOptions, 'default');

        return requestedDisplay;
    }

    getCustomComponent(template, element, widgetProps = {}) {
        if (Object.keys(this.displayMap).indexOf(element) === -1) {
            console.warn('Unknownw standard component: ' + element);
            return null;
        }
        //Get display option for element in theme
        let themeDisplay = _.get(template, `theme.display.${element}`);

        //Check if widget has custom display property for element
        let widgetDisplay = _.get(widgetProps, `${element}Display`);

        //Get all display options for component
        let elementDisplayOptions = _.get(this.displayMap, `${element}`);

        //Get component with display option from widget custom display or from theme
        let requestedDisplay = _.get(elementDisplayOptions, widgetDisplay || themeDisplay);

        //If no such display option found, return default display option
        if (!requestedDisplay) requestedDisplay = _.get(elementDisplayOptions, 'default');

        return requestedDisplay;
    }

    getDisplay = (template, element, widgetProps = {}) => {
        return this.getCustomComponent(template, element, widgetProps);
    };

    getStandardComponent = (template, element, widgetProps = {}) => {
        return this.getCustomComponent(template, element, widgetProps);
    };

    getDefaultProp = (parameter, widgetId, template, widgetProps = {}) => {
        if (widgetProps[parameter]) return widgetProps[parameter];

        let val = _.get(template, `widgetProps.${widgetId}.${parameter}`, widgetProps[parameter]);
        return val;
    };

    getLayoutType = (template, element, widgetProps = {}) => {};

    getDisplayPropType(element, others) {
        let label = _.camelCase(element);
        label = label.charAt(0).toUpperCase() + label.slice(1);
        return {
            key: `${element}Display`,
            type: 'select_picker',
            label: `${label} render component`,
            scope: 'template',
            defaultValue: null,
            options: [
                { text: 'Inherit from theme', value: null },
                ...Object.keys(this.displayMap[element]).map(d => ({
                    text: d,
                    value: d
                }))
            ],
            ...others
        };
    }
}

const styledUI = new StyledUIFactory();
const displayMap = styledUI.displayMap;
const skins = styledUI.skins;
const getDisplayPropType = styledUI.getDisplayPropType;

export { styledUI, displayMap, getDisplayPropType, skins };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/StyledUI.js
 **/